const styles = ({ COLORS, BREAKPOINTS }) => ({
  container: {
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      overflow: 'auto'
    }
  },
  table: {
    width: '100%'
  },
  left: {
    textAlign: 'left'
  },
  selectAll: {
    color: COLORS.BLUE.NORMAL,
    cursor: 'pointer',
    fontWeight: 'bold',
    userSelect: 'none'
  },
  icon: {
    width: '20px',
    height: '20px',
    position: 'relative',
    top: '4px'
  }
})

export default styles
